export const EDIT_RELEASE = '[Release] Edit Release';

export const CLEAN_RELEASE = '[Release] Clean Release Draft';

export const START_RELEASE = '[Release] Start Release';

export const ADD_ARTIST_TO_RELEASE = '[Release] Add Artist To Release';
export const CREATE_RELEASE = '[Release] Create Release';
export const CREATE_RELEASE_SUCCESS = '[Release] Create Release Success';
export const CREATE_RELEASE_ERROR = '[Release] Create Release Error';

export const PUBLISH_RELEASE = '[Release] Publish Release';
export const PUBLISH_RELEASE_SUCCESS = '[Release] Publish Release Success';
export const PUBLISH_RELEASE_ERROR = '[Release] Publish Release Error';

export const CONFIRM_TAKEDOWN_RELEASE = '[Release] Confirm Takedown Release';
export const CONFIRM_CANCEL_RELEASE_CHANGES =
  '[Release] Confirm Cancel Release Changes';
export const TAKEDOWN_RELEASE = '[Release] Takedown Release';
export const TAKEDOWN_RELEASE_SUCCESS = '[Release] Takedown Release Success';
export const TAKEDOWN_RELEASE_ERROR = '[Release] Takedown Release Error';

export const UPDATED_TAKEDOWN_RELEASE = '[Release] Updated Takedown Release';
export const UPDATED_TAKEDOWN_RELEASE_SUCCESS =
  '[Release] Updated Takedown Release Success';
export const UPDATED_TAKEDOWN_RELEASE_ERROR =
  '[Release] Updated Takedown Release Error';

export const UNLOCK_RELEASE = '[Release] Unlock release';

export const UPDATE_RELEASE = '[Release] Update Release';
export const UPDATE_RELEASE_SUCCESS = '[Release] Update Release Success';
export const UPDATE_RELEASE_ERROR = '[Release] Update Release Error';

export const CANCEL_RELEASE = '[Release] Cancel Release';
export const CANCEL_RELEASE_SUCCESS = '[Release] Cancel Release Success';
export const CANCEL_RELEASE_ERROR = '[Release] Cancel Release Error';

export const CANCEL_PENDING_TAKEDOWN = '[Release] Cancel Pending Takedown';
export const CANCEL_PENDING_TAKEDOWN_SUCCESS =
  '[Release] Cancel Pending Takedown Success';
export const CANCEL_PENDING_TAKEDOWN_ERROR =
  '[Release] Cancel Pending Takedown Error';

export const VALIDATE_RELEASE_ARTISTS = '[Release] Validate Artists';
export const VALIDATE_RELEASE_ARTISTS_SUCCESS =
  '[Release] Validate Artists Success';
export const VALIDATE_RELEASE_ARTISTS_ERROR =
  '[Release] Validate Artists Error';

export const LOAD_RELEASE = '[Release] Load Release';
export const LOAD_RELEASE_SUCCESS = '[Release] Load Release Success';
export const LOAD_RELEASE_ERROR = '[Release] Load Release Error';

export const CHANGE_ACTIVE_LIST = '[Release] Change Active List';

export const LIST_RELEASES_SUMMARY = '[Release] List Releases summary';
export const LIST_RELEASES_SUMMARY_SUCCESS =
  '[Release] List Releases summary Success';
export const LIST_RELEASES_SUMMARY_ERROR =
  '[Release] List Releases summary Error';

export const LIST_RELEASES = '[Release] List Releases';
export const LIST_RELEASES_SUCCESS = '[Release] List Releases Success';
export const LIST_RELEASES_ERROR = '[Release] List Releases Error';

export const LIST_MULTIPLE_ARTIST_RELEASES =
  '[Release] List Multiple Artists Releases';
export const LIST_MULTIPLE_ARTIST_RELEASES_SUCCESS =
  '[Release] List Multiple Artists Releases Success';
export const LIST_MULTIPLE_ARTIST_RELEASES_ERROR =
  '[Release] List Multiple Artists  Releases Error';

export const LIST_RELEASES_ARTIST = '[Release] List Releases Artist';
export const LIST_RELEASES_ARTIST_SUCCESS =
  '[Release] List Releases Artist Success';
export const LIST_RELEASES_ARTIST_ERROR = '[Release] List Releases Error';

export const LIST_RELEASES_DEACTIVATED_ARTIST =
  '[Release] List Releases Deactivated Artist';
export const LIST_RELEASES_DEACTIVATED_ARTIST_SUCCESS =
  '[Release] List Releases Deactivated Artist Success';
export const LIST_RELEASES_DEACTIVATED_ARTIST_ERROR =
  '[Release] List Releases Deactivated Artist Error';

export const LIST_FEATURING = '[Release] List Featuring';
export const LIST_FEATURING_SUCCESS = '[Release] List Featuring Success';
export const LIST_FEATURING_ERROR = '[Release] List Featuring Error';

export const UPDATE_FIELD = '[Release] Update Field';
export const RELEASE_ON_CHANGE_INPUT_FIELD = '[Release] On Change Input Field';

export const SHARE_RELEASE = '[Release] Share Release';

export const RESET_RELEASE_STORE = '[Release] Reset store';

export const UPDATE_RELEASE_STORE_ERROR =
  '[Release] Update Release Store Error';
